import React, { useEffect, useState, useCallback } from "react";
import { Mail, Star, AtSign } from "lucide-react";
import { FaInstagram, FaTiktok, FaLinkedinIn, FaYoutube, FaGlobe } from "react-icons/fa";
import { FaThreads } from "react-icons/fa6";



export default function Linktree() {
    const [showBackground, setShowBackground] = useState(false);
    const links = [
        {
            label: 'TikTok', url: 'https://tiktok.com/@eryndraeventos',
            icon: FaTiktok
        },
        {
            label: 'Instagram', url: 'https://instagram.com/eryndraeventos',
            icon: FaInstagram
        },
        {
            label: 'Web', url: 'https://eryndraeventos.es',
            icon: FaGlobe
        },
        {
            label: 'YouTube', url: 'https://www.youtube.com/@EryndraEventos',
            icon: FaYoutube
        },
        {
            label: 'Threads', url: 'https://www.threads.com/@eryndraeventos',
            icon: FaThreads
        },
        {
            label: 'Linkedin', url: 'https://www.linkedin.com/in/eryndraeventos/',
            icon: FaLinkedinIn
        },
        {
            label: 'Contacto', url: 'mailto:eryndraeventos@gmail.com',
            icon: Mail
        },
    ];



    return (
//         <section className="min-h-screen w-full bg-gradient-to-b from-eryndra-forest to-eryndra-ivory py-12 px-4">
//             <div className="rounded-3xl bg-eryndra-hero shadow-lg mx-auto w-full max-w-md text-center p-6 
//   min-h-screen flex flex-col items-center justify-center  bg-cover bg-center text-center z-10 py-20 relative">


//                 <div
//                     className="py-10">

//                     <h1 className="font-title text-5xl md:text-8xl  mb-4  tracking-widest text-shadow-lg">
//                         eRYNDRA eVeNTOS
//                     </h1>
//                     <p className="text-lg md:text-2xl  text-shadow-DEFAULT">
//                         Tu historia, hecha Magia.
//                     </p>

//                 </div>
//                 <div className="rounded-3xl bg-eryndra-forest/80 shadow-lg mx-auto w-full max-w-md text-center p-6 border border-eryndra-gold">
//                     {/* Descripción */}
//                     <p className="text-sm text-eryndra-gold font-semibold ">Sevilla - Córdoba </p>
//                     <p className="text-sm text-eryndra-gold font-semibold mb-6">Eventos de fantasía y libros</p>

//                     {/* Iconos sociales */}
//                     <div className="flex justify-center gap-4 text-2xl text-eryndra-gold mb-6">
//                         {links.map((link, index) => {
//                             const Icon = link.icon;
//                             return (
//                                 <a key={index}
//                                     href={link.url} target="_blank"><link.icon /></a>
//                             );
//                         })}

//                     </div>
//                 </div>

//             </div>
//         </section>


        <section className="min-h-screen w-full bg-gradient-to-b to-eryndra-forest from-eryndra-cream py-12 px-4">
        <div className="rounded-3xl bg-eryndra-hero shadow-lg mx-auto w-full max-w-md text-center p-6 
   min-h-screen flex flex-col items-center justify-center  bg-cover bg-center text-center z-10 py-20 relative">
            <div
                className="py-10">

                <h1 className="font-title text-5xl   mb-4  tracking-widest text-shadow-lg">
                    eRYNDRA eVeNTOS
                </h1>
                <p className="text-lg md:text-2xl  text-shadow-DEFAULT">
                    Tu historia, hecha Magia.
                </p>
                
            </div>

            {/* FICHAS para MÓVIL */}
            <div className="flex flex-col gap-4 w-full max-w-sm px-4 text-center mx-auto lg:max-w-2xl">
                {links.map((link, index) => {
                    const Icon = link.icon;
                    return (
                        <a
                            key={index}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border border-eryndra-gold  text-eryndra-gold rounded-lg bg-eryndra-forest/80 py-2 px-6 rounded-xl text-center hover:bg-eryndra-gold transition hover:text-eryndra-forest transition-colors duration-300"
                        >
                            <div className="flex items-center justify-center gap-3  rounded-xl text-center">
                            {
                                link.icon === FaTiktok
                                ? <Icon className="w-5 h-5 " />
                                : 
                                link.icon === FaLinkedinIn
                                ? <Icon className="w-5 h-5 " />
                                : 
                                <Icon className="w-6 h-6 " />
                            }                            
                                <h2 className="text-xl font-bellefair pt-[6px]">{link.label}</h2>
                            </div>
                        </a>
                    );
                })}
            </div>

        </div>
        </section>
    );
}
